export default __webpack_public_path__ + "static/media/thumb.4dcff2c7.png";